import axiosPost from "../axiosPost";

export const migraTipoDePasoUpd = async (
    {
        migraTipoDePasoId,
        migraTipoDePasoCod,
        migraTipoDePasoNombre,
        migraTipoDePasoVersion,
    },
    credentials
) => {
    const body = {
        service: "MigraTipoDePasoUpd",
        params: {
            migraTipoDePasoId,
            migraTipoDePasoCod,
            migraTipoDePasoNombre,
            migraTipoDePasoVersion,
        },
    };

    return await axiosPost(body, credentials);
};
